export default {
    root: {},
    input: {
        height: '1.5rem',
        '&:disabled': {
            background: 'gainsboro'
        }
    }
  };
  